import { render, staticRenderFns } from "./common-not-found.view.vue?vue&type=template&id=a6766198&"
import script from "./common-not-found.view.vue?vue&type=script&lang=ts&"
export * from "./common-not-found.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports